import { render, staticRenderFns } from "./PurpleCard2.vue?vue&type=template&id=f54f2158&scoped=true"
import script from "./PurpleCard2.vue?vue&type=script&lang=js"
export * from "./PurpleCard2.vue?vue&type=script&lang=js"
import style0 from "./PurpleCard2.vue?vue&type=style&index=0&id=f54f2158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54f2158",
  null
  
)

export default component.exports